"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCollapse = exports.collapseContext = void 0;
var react_1 = require("react");
exports.collapseContext = react_1.createContext(null);
function useCollapse() {
    var contextValue = react_1.useContext(exports.collapseContext);
    if (contextValue == null) {
        throw Error('CollapsePanel should be used in Collapse.');
    }
    return contextValue;
}
exports.useCollapse = useCollapse;
//# sourceMappingURL=hooks.js.map